import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faUser } from '@fortawesome/pro-light-svg-icons'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import useCampaignContact from '@hooks/useCampaignContact'
import useContact from '@hooks/useContact'

import type { CampaignContactModel } from '@models/types'

interface CampaignContactProps {
  campaignContact: CampaignContactModel,
}

const CampaignContactListItem = (props: CampaignContactProps) => {
  const { campaignContact } = props

  const {
    callbacks: { deleteCampaignContact },
    campaign,
    contact,
  } = useCampaignContact(campaignContact)

  const {
    // @ts-expect-error TS2339
    company_name, contact_type, email, mobile, title,
  } = contact

  const contactIcon = company_name ? faBuilding : faUser

  const { callbacks: { createOrEditContact } } = useContact(contact)

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2740
      onClick={() => createOrEditContact({ callbacks: { deleteFn: deleteCampaignContact }, campaign })}
      secondaryText={(
        <Box alignItems="center">
          <FontAwesomeIcon icon={contactIcon} />

          <Text color="bodyFontLightColor" marginLeft="small">{snakeToTitleCase(contact_type)}</Text>
        </Box>
      )}
      title={(
        <Text className="mp-mask">
          {title}
        </Text>
      )}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText textProps={{ textAlign: 'right' }}>
        <Text className="mp-mask">{mobile}</Text>

        <Text className="mp-mask" color="bodyFontLightColor" variant="ellipsis">{email}</Text>
        {/*
        // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CampaignContactListItem
